import { render, staticRenderFns } from "./LocalSwitcher.vue?vue&type=template&id=559425fb&scoped=true&"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LocalSwitcher.vue?vue&type=style&index=0&id=559425fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559425fb",
  null
  
)

export default component.exports